(function($) {
    function getPortalRootForPanel($panel) {
      var $dialogInner = $panel.closest('.cart-drawer__inner');
      if ($dialogInner.length) return $dialogInner.first();

      $dialogInner = $('.cart-drawer__dialog[open]').find('.cart-drawer__inner').first();
      if ($dialogInner.length) return $dialogInner;

      return $(document.body);
    }

    function getLineFromElement($el) {
      var line = parseInt($el.attr('data-cart-line'), 10);
      if (line && !isNaN(line)) return line;

      var $panel = $el.closest('.gift-card-panel[data-cart-line]');
      if ($panel.length) {
        line = parseInt($panel.attr('data-cart-line'), 10);
        if (line && !isNaN(line)) return line;
      }

      var $row = $el.closest('tr[role="row"]');
      if (!$row.length) return null;

      if (!line || isNaN(line)) {
        var $qtyInput = $row.find('input[name="updates[]"][data-cart-line]');
        if ($qtyInput.length) {
          line = parseInt($qtyInput.attr('data-cart-line'), 10);
        }
      }

      return !line || isNaN(line) ? null : line;
    }

    function findPanel(line) {
      return $('.gift-card-panel[data-cart-line="' + line + '"]');
    }

    function findMessageInput(line) {
      return $('.gift-card-message__textarea[data-cart-line="' + line + '"]');
    }

    function findRowByLine(line) {
      var $row = $('input[name="updates[]"][data-cart-line="' + line + '"]').closest('tr[role="row"]');
      if ($row.length) return $row.first();

      return $('tr[role="row"]').filter(function () {
        var $panel = $(this).find('.gift-card-panel[data-cart-line]');
        return parseInt($panel.attr('data-cart-line'), 10) === line;
      }).first();
    }

    function movePanelToPortal($panel) {
      if (!$panel.length || $panel.data('panelPortaled')) return;

      $panel.data('panelPortaled', true);
      $panel.data('originParent', $panel[0].parentNode);
      $panel.data('originNextSibling', $panel[0].nextSibling || null);
      getPortalRootForPanel($panel).append($panel);
    }

    function restorePanelFromPortal($panel) {
      if (!$panel.length || !$panel.data('panelPortaled')) return;

      var originParent = $panel.data('originParent');
      var originNextSibling = $panel.data('originNextSibling');

      if (originParent && originParent.nodeType === 1) {
        if (originNextSibling && originNextSibling.parentNode === originParent) {
          originParent.insertBefore($panel[0], originNextSibling);
        } else {
          originParent.appendChild($panel[0]);
        }
      }

      $panel.removeData('panelPortaled');
      $panel.removeData('originParent');
      $panel.removeData('originNextSibling');
    }

    function openPanel(line) {
      var $panel = findPanel(line);
      if (!$panel.length) return;

      movePanelToPortal($panel);
      $panel.addClass('is-open').attr('aria-hidden', 'false');

      var $message = findMessageInput(line);
      if ($message.length) {
        setTimeout(function () {
          $message.focus();
        }, 200);
      }
    }

    function closePanel(line) {
      var $panel = findPanel(line);
      if (!$panel.length) return;

      $panel.removeClass('is-open').attr('aria-hidden', 'true');
      setTimeout(function () {
        restorePanelFromPortal($panel);
      }, 220);
    }

    function resetToggleIfMessageEmpty(line) {
      var $toggle = $('.gift-card-toggle__input[data-cart-line="' + line + '"]').first();
      if (!$toggle.length || !$toggle.prop('checked')) return false;

      var $messageInput = findMessageInput(line).first();
      var messageValue = $messageInput.length ? $.trim($messageInput.val() || '') : '';
      if (messageValue !== '') return false;

      $toggle.prop('checked', false);
      updateLineProperties($toggle);
      return true;
    }

    function resetAllTogglesIfMessageEmpty() {
      $('.gift-card-toggle__input:checked').each(function () {
        var line = getLineFromElement($(this));
        if (!line) return;
        resetToggleIfMessageEmpty(line);
      });
    }

    function getWordLimit($messageInput) {
      var configuredLimit = parseInt($messageInput.attr('data-max-words'), 10);
      return !isNaN(configuredLimit) && configuredLimit > 0 ? configuredLimit : 120;
    }

    function truncateToWordLimit(value, maxWords) {
      if (!value) return '';

      var words = $.trim(value).match(/\S+/g) || [];
      if (words.length <= maxWords) return value;

      return words.slice(0, maxWords).join(' ');
    }

    function enforceMessageWordLimit($messageInput) {
      if (!$messageInput.length) return false;

      var currentValue = $messageInput.val() || '';
      var maxWords = getWordLimit($messageInput);
      var limitedValue = truncateToWordLimit(currentValue, maxWords);
      var wasTrimmed = limitedValue !== currentValue;

      if (wasTrimmed) {
        $messageInput.val(limitedValue);
      }

      return wasTrimmed;
    }

    function updateLineProperties($trigger) {
      var line = getLineFromElement($trigger);
      if (!line) return;
      var $row = findRowByLine(line);
      if (!$row.length) return;

      var $messageInput = findMessageInput(line).first();
      var $toggleInput = $('.gift-card-toggle__input[data-cart-line="' + line + '"]').first();

      var properties = {};
      if ($messageInput.length) {
        enforceMessageWordLimit($messageInput);
        properties['Message'] = $messageInput.val().trim();
      }
      if ($toggleInput.length) {
        properties['Gift card'] = $toggleInput.prop('checked') ? 'Yes' : 'No';
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          properties: properties
        })
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          console.log('Cart updated with properties', cart);
          var $summaryText = $('.gift-card-summary[data-cart-line="' + line + '"] .gift-card-summary__text');
          if ($summaryText.length) {
            $summaryText.text(properties['Message'] ? properties['Message'] : 'No message added');
          }
          var $variants = $row.find('.cart-items__variants');
          var selector = '.cart-items__properties--message[data-cart-line="' + line + '"]';
          var $messageRow = $row.find(selector);
          var messageText = properties['Message'];

          if ($messageRow.length) {
            $messageRow.remove();
          }

          if (messageText && $variants.length) {
            console.log('here');
            $variants.append(
              '<div class="cart-items__properties cart-items__properties--message" data-cart-line="' +
                line +
                '"><dt>Message:</dt><dd class="gift-card-message-display">' +
                ' ' + messageText + ' ' +
                '</dd><dd><a href="javascript:void(0)" class="edit-msg-btn" data-open-message data-cart-line="' +
                line +
                '">Edit</a></dd></div>'
            );
          }
        })
        .catch(function (err) {
          console.error('Error updating cart properties', err);
        });
    }

    $(document).on('change', '.gift-card-toggle__input', function () {
      var $toggle = $(this);
      var line = getLineFromElement($toggle);
      if (!line) return;

      if ($toggle.prop('checked')) {
        openPanel(line);
      } else {
        // Clear message when toggle is turned off
        var $messageInput = findMessageInput(line).first();
        if ($messageInput.length) {
          $messageInput.val('');
        }
        closePanel(line);
      }

      updateLineProperties($toggle);
    });

    $(document).on('input', '.gift-card-message__textarea', function () {
      enforceMessageWordLimit($(this));
    });

    $(document).on('change', '.gift-card-message__textarea', function () {
      enforceMessageWordLimit($(this));
      updateLineProperties($(this));
    });

    $(document).on('click', '[data-save-message]', function () {
      var $button = $(this);
      var line = getLineFromElement($button);
      if (line) {
        var resetToNo = resetToggleIfMessageEmpty(line);
        if (!resetToNo) {
          updateLineProperties($button);
        }
        closePanel(line);
      } else {
        updateLineProperties($button);
      }

      console.log(line);
    });

    $(document).on('click', '[data-panel-close]', function () {
      var line = getLineFromElement($(this));
      if (line) {
        closePanel(line);
        resetToggleIfMessageEmpty(line);
      }
    });

    $(document).on('click', '[data-open-message]', function () {
      var $button = $(this);
      var line = getLineFromElement($button);
      if (!line) return;

      var $toggle = $('.gift-card-toggle__input[data-cart-line="' + line + '"]');
      if ($toggle.length && !$toggle.prop('checked')) {
        $toggle.prop('checked', true);
        updateLineProperties($toggle);
      }
      openPanel(line);
    });

    document.addEventListener(
      'close',
      function (event) {
        var dialog = event.target;
        if (!(dialog instanceof HTMLDialogElement)) return;
        if (!dialog.classList.contains('cart-drawer__dialog')) return;

        resetAllTogglesIfMessageEmpty();
      },
      true
    );
})(jQuery)